import { useQuery } from '@tanstack/react-query'
import { api } from '../client'
import type { LinhaDeUsoDaIa } from '../../types/usoDaIa'

/**
 * O consumo da análise por IA, mês a mês.
 *
 * @returns a consulta do uso
 */
export function useUsoDaIa() {
  return useQuery({
    queryKey: ['admin', 'uso-da-ia'],
    queryFn: async () => (await api.get<LinhaDeUsoDaIa[]>('/admin/uso-da-ia')).data,
  })
}
